<template>
    <div class="modalCalendarCreateContainer">
        <div class="headerCalendarCreate">
            <h2>{{isEdit ? 'Editar Registro' : 'Crear Nuevo Registro'}}</h2>
            <p @click="closeCalendarCreateModal">X</p>
        </div>
        <form @submit.prevent="switchFormTwo">
            <div class="formCalendarCreate">
                <div class="formPeriodoBanner">
                    <label for="">Periodo Banner</label>
                    <input ref="periodoBannerInput" @input="validateInput('periodoBanner')" v-model="calendarCreateObject.periodoBanner" type="text" required>
                </div>
                <div class="formPeriodo">
                    <label for="">Periodo</label>
                    <div>
                        <input ref="periodoInput" @input="validateInput('periodo')"  v-model="calendarCreateObject.periodo" type="text" required>
                        <select v-model="calendarCreateObject.entrada" required>
                            <option value="" disabled></option>
                            <option value="I1">I1</option>
                            <option value="I2">I2</option>
                            <option value="I3">I3</option>
                            <option value="I4">I4</option>
                            <option value="I5">I5</option>
                        </select>
                    </div> 
                </div>
                <div class="formPeriodoAnterior">
                    <label for="">Periodo Anterior</label>
                    <input ref="periodoAnteriorInput" @input="validateInput('periodoAnterior')" v-model="calendarCreateObject.periodoAnterior" type="text" required>
                </div>
                <div class="formPeriodoSiguiente">
                    <label for="">Periodo Siguiente</label>
                    <input ref="periodoSiguienteInput" @input="validateInput('periodoSiguiente')"  v-model="calendarCreateObject.periodoSiguiente" type="text" required>
                </div>
                <div class="formFechaInicioPago">
                    <label for="">Inicio Pago</label>
                    <input v-model="calendarCreateObject.inicioPago"  type="date" required>
                </div>
                <div class="formFechaInicioPeriodo">
                    <label for="">Inicio Periodo</label>
                    <input v-model="calendarCreateObject.inicioPeriodo" type="date" required>
                </div>
                <div class="formFechaCorte">
                    <label for="">Corte</label>
                    <input v-model="calendarCreateObject.corte" type="date" ref="fechaCorte" @input="validateDateCorte" required>
                </div>
                <div class="formFechaFinPago">
                    <label for="">Fin Pago</label>
                    <input v-model="calendarCreateObject.finPago" type="date" ref="fechaFinPago" @input="validateDateFinPago" required>
                </div>
                <div class="formFechaFinPeriodo">
                    <label for="">Fin Periodo</label>
                    <input v-model="calendarCreateObject.finPeriodo" type="date" ref="fechaFinPerido" @input="validateDateFinPeriodo" required>
                </div>
                <div class="formFechaInicioSiguientePeriodo">
                    <label for="">Inicio Siguiente Periodo</label>
                    <input v-model="calendarCreateObject.inicioSiguientePeriodo" type="date" ref="fechaInicioSiguientePeriodo" @input="validateDateInicioSiguientePeriodo" required>
                </div>
                <div class="formEstado">
                    <label for="">Estado</label>
                    <select v-model="calendarCreateObject.estado" required>
                        <option value="" disabled></option> 
                        <option value=1>Activo</option>
                        <option value=0>Inactivo</option>
                    </select>
                </div>
            </div>
            <div class="formButtonSubmit">
                <button type="submit">Siguiente</button>
            </div>
        </form>
    </div>
</template>
<script>
export default{
    props: {
        CalendarCreateObjectByParent: Object,
        IsEdit: Boolean,
    },
    data(){
        return{
            isEdit: this.IsEdit,
            calendarCreateObject: {
                calendarId: '',
                periodoBanner: '',
                periodo: '',
                periodoAnterior: '',
                periodoSiguiente: '',
                inicioPago: '',
                inicioPeriodo: '',
                corte: '',
                finPago: '',
                finPeriodo: '',
                inicioSiguientePeriodo: '',
                estado: '',
                entrada: '',
            },
            entry : '',
        }
    },
    methods: {
        //Método para poner en 0 las variables
        resetVariables(){
            this.isEdit = null;
            this.calendarCreateObject = {
                calendarId: '',
                periodoBanner: '',
                periodo: '',
                periodoAnterior: '',
                periodoSiguiente: '',
                inicioPago: '',
                inicioPeriodo: '',
                corte: '',
                finPago: '',
                finPeriodo: '',
                inicioSiguientePeriodo: '',
                estado: '',
                entrada: '',
            },
            this.entry = '';
        },
        //Método para cerrar el modal
        closeCalendarCreateModal(){
            this.$emit('closeCalendarCreateModal');
            this.resetVariables();
        },
        //Método para cambiar al formulario de programas y pasar los datos del formulario
        switchFormTwo(){
            this.$emit('switchFormTwo', this.calendarCreateObject);
        },
        //Método para tomar la data si la hay del componente padre
        componentInit() {
            this.calendarCreateObject = this.CalendarCreateObjectByParent;
        },  
        //Método para validar longitud y caracteres de los campos
        validateInput(period) {
            const value = this.calendarCreateObject[period];
            if (!/^\d+$/.test(value)) {
                this.calendarCreateObject[period] = '';
            } else {
                this.$refs[period + 'Input'].setCustomValidity('');
            }

            if (period === 'periodo') {
                if (this.calendarCreateObject[period].length !== 4) {
                    const errorMessage = 'El período debe tener 4 dígitos.';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else if (this.calendarCreateObject[period] !== this.calendarCreateObject.periodoBanner.slice(0, 4)) {
                    const errorMessage = 'El año debe coincidir con el Periodo Banner';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else {
                    this.$refs[period + 'Input'].setCustomValidity('');
                }
            } else if (period === 'periodoAnterior') {
                if (this.calendarCreateObject[period] !== '0' && this.calendarCreateObject[period].length !== 6) {
                    const errorMessage = 'El período debe tener 6 dígitos si es diferente de 0.';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else if (
                    parseInt(this.calendarCreateObject.periodoAnterior) >= parseInt(this.calendarCreateObject.periodoBanner) ||
                    parseInt(this.calendarCreateObject.periodoAnterior) >= parseInt(this.calendarCreateObject.periodoSiguiente)
                ) {
                    const errorMessage = 'Periodo Anterior debe ser menor a Periodo Banner y Periodo Siguiente.';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else {
                    this.$refs[period + 'Input'].setCustomValidity('');
                }
            } else if (period === 'periodoSiguiente') {
                if (this.calendarCreateObject[period].length !== 6) {
                    const errorMessage = 'El período debe tener 6 dígitos.';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else if (
                    parseInt(this.calendarCreateObject.periodoSiguiente) <= parseInt(this.calendarCreateObject.periodoBanner) ||
                    parseInt(this.calendarCreateObject.periodoSiguiente) <= parseInt(this.calendarCreateObject.periodoAnterior)
                ) {
                    const errorMessage = 'Periodo Siguiente debe ser mayor a Periodo Banner y Periodo Anterior.';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else {
                    this.$refs[period + 'Input'].setCustomValidity('');
                }
            } else {
                if (this.calendarCreateObject[period].length !== 6) {
                    const errorMessage = 'El período debe tener 6 dígitos.';
                    this.$refs[period + 'Input'].setCustomValidity(errorMessage);
                } else {
                    this.$refs[period + 'Input'].setCustomValidity('');
                }
            }  
        },
        //Método para validar la fecha Corte
        validateDateCorte(){
            if(this.calendarCreateObject.corte < this.calendarCreateObject.inicioPeriodo){
                const errorMessage = 'Fecha de corte no puede ser menor a Fecha de Inicio Periodo.';
                this.$refs.fechaCorte.setCustomValidity(errorMessage);
            } else {
                this.$refs.fechaCorte.setCustomValidity('');
            }
        },
        //Método para validar la fecha fin pago
        validateDateFinPago(){
            if(this.calendarCreateObject.finPago < this.calendarCreateObject.inicioPago){
                const errorMessage = 'Fecha de Fin Pago no puede ser menor a Fecha de Inicio Pago.';
                this.$refs.fechaFinPago.setCustomValidity(errorMessage);
            } else {
                this.$refs.fechaFinPago.setCustomValidity('');
            }
        },
        //Método para validar la fecha fin periodo
        validateDateFinPeriodo(){
            if(this.calendarCreateObject.finPeriodo < this.calendarCreateObject.inicioPeriodo){
                const errorMessage = 'Fecha de Fin Periodo no puede ser menor a Fecha de Inicio Periodo.';
                this.$refs.fechaFinPerido.setCustomValidity(errorMessage);
            } else {
                this.$refs.fechaFinPerido.setCustomValidity('');
            }
        },
        //Método para validar la fecha inicio siguiente periodo
        validateDateInicioSiguientePeriodo(){
            if(this.calendarCreateObject.inicioSiguientePeriodo < this.calendarCreateObject.finPeriodo){
                const errorMessage = 'Fecha de Inicio Siguiente Periodo no puede ser menor a Fecha de Fin Periodo.';
                this.$refs.fechaInicioSiguientePeriodo.setCustomValidity(errorMessage);
            } else {
                this.$refs.fechaInicioSiguientePeriodo.setCustomValidity('');
            }
        },
    },
    mounted() {
        this.componentInit();
    },

    
}  
</script>
<style scoped>
    .modalCalendarCreateContainer{
        width: 80rem;
        height: 30rem;
        background-color: #fff;
        padding: 2rem;
    }
    .headerCalendarCreate{
        display: flex;
        justify-content: space-between;
    }
    .headerCalendarCreate h2{
        color: #d0ab4b;
        font-weight: bold;
        font-size: 1.5rem;
    }
    .headerCalendarCreate p{
        color: #d0ab4b;
        font-weight: bold;
        font-size: 1.5rem;
        cursor: pointer;
    }
    .formCalendarCreate{
        display: grid;
        grid-template-columns: repeat(5, 1fr); /* Crea 5 columnas de igual ancho */
        grid-template-rows: repeat(2, 1fr);    /* Crea 2 filas de igual alto */
        align-self: center;
        height: 17rem;
        margin-bottom: 1rem;
    }
    .formCalendarCreate div{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .formCalendarCreate label{
        font-weight: bold;
        font-size: 1rem;
    }
    .formCalendarCreate div input{
        width: 10rem;
        height: 2rem;
        border: none;
        background-color: rgb(245, 248, 249);
        outline-color: #d0ab4b;
        padding: 0.2rem;
    }
    .formCalendarCreate div input:focus {
        border-bottom: 3px solid #d0ab4b;
    }
    .formCalendarCreate div select{
        width: 10rem;
        height: 2rem;
        border: none;
        background-color: rgb(245, 248, 249);
        outline-color: #d0ab4b;
        padding: 0.2rem;
    }
    .formCalendarCreate div select:focus {
        border-bottom: 3px solid #d0ab4b;
    }
    .formCalendarCreate .formPeriodo div{
        display: flex;
        flex-direction: row;
    }

    .formCalendarCreate .formPeriodo div select{
        width: 3rem;
        border-left: 0.001rem solid rgb(39, 40, 41);
    }
    .formButtonSubmit{
        display: flex;
        justify-content: flex-end;
    }
    .formButtonSubmit button{
        background-color: #d0ab4b;
        color: white;
        border: none;
        font-size: 1rem;
        padding: 0.3rem 1rem;
        border-radius: 0.3rem;
    }
</style>